import { CreateShippingDeadlineExtensionArgs } from 'types/api/arguments/create-shipping-deadline-extension-args'

import { api } from './api'

export const createShippingDeadlineExtension = (args: CreateShippingDeadlineExtensionArgs) =>
  api.post(`shipments/${args.shipmentId}/deadline_extension`, {
    deadline_extension: {
      key: args.key,
      reason: args.reason,
    },
  })
